import { Card } from 'antd';

import TreatmentsTable from '../../components/Treatments';

function Treatment() {
  return (
    <Card>
      <TreatmentsTable breadcrumb="List of Livestock treatments" title="Livestock treatments" />
    </Card>
  );
}

export default Treatment;
